const MARKET_API_KEY = process.env.NEXT_PUBLIC_CLIENT_MARKET_API_KEY ?? ""
/** Base for server-side fetch only; browser uses same-origin /api/v1/... proxy (CORS). */
const TRANSACTIONS_API_BASE_URL =
  process.env.NEXT_PUBLIC_TRANSACTIONS_API_BASE_URL?.trim() || ""

function readClientAuthToken(): string | null {
  if (typeof window === "undefined") return null
  try {
    const committed = window.localStorage.getItem("auth_token")?.trim()
    if (committed) return committed
  } catch {
    // ignore
  }
  try {
    const pending = window.sessionStorage.getItem("signin_pending_auth_token")?.trim()
    if (pending) return pending
  } catch {
    // ignore
  }
  return null
}

export function createMarketApiFetch() {
  return (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const headers: Record<string, string> = {
      ...((init?.headers as Record<string, string> | undefined) ?? {}),
    }

    let url: RequestInfo | URL = input

    if (typeof input === "string" && input.startsWith("/")) {
      if (typeof window !== "undefined") {
        url = input
        delete headers["x-api-key"]
        delete headers["X-Api-Key"]

        const token = readClientAuthToken()
        if (token && !headers.Authorization && !headers.authorization) {
          const clean = token.startsWith("Bearer ") ? token.slice(7) : token
          headers.Authorization = `Bearer ${clean}`
        }
      } else {
        const base = TRANSACTIONS_API_BASE_URL.replace(/\/+$/, "")
        url = base ? `${base}${input}` : input
        if (MARKET_API_KEY) headers["x-api-key"] = MARKET_API_KEY
      }
    } else if (typeof input === "string" && MARKET_API_KEY) {
      headers["x-api-key"] = MARKET_API_KEY
    }

    return fetch(url, {
      ...init,
      headers,
    })
  }
}

